import { useTransition, animated } from '@react-spring/web';
import { Spacing8 } from 'autogen/design-tokens/tokens';
import type { GlobalUspItemModel } from 'autogen/swagger/all';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import USP from './USP';

const ItemWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 ${Spacing8};
`;

const AnimatedItemWrapper = animated<any>(ItemWrapper);

export default function MobileUSPHeader({ usps }: { usps: GlobalUspItemModel[] }) {
    const [items, setItems] = useState<typeof usps>();

    const transitions = useTransition(items, {
        from: { transform: 'translateY(100%)' },
        enter: { transform: 'translateY(0%)' },
        leave: { transform: 'translateY(-100%)' },
        config: {
            tension: 700,
            friction: 50,
            mass: 1
        }
    });

    useEffect(() => {
        let timer;
        let index = 0;

        function loopItems() {
            const nextItem = usps[index] || usps[0];
            index = index >= usps.length - 1 ? 0 : (index += 1);

            setItems([nextItem]);

            timer = setTimeout(loopItems, nextItem.activeDurationMilliseconds || 4000);
        }

        loopItems();

        return () => {
            clearTimeout(timer);
        };
    }, []);

    return transitions(
        (style, usp) =>
            usp && (
                <AnimatedItemWrapper style={style}>
                    <USP {...usp} />
                </AnimatedItemWrapper>
            )
    );
}
